import { useMutation } from '@apollo/client';
import { graphql } from '../gql';

const USER_LOGIN = graphql(`
  mutation userLogin($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      ... on NotAuthorizedError {
        code
        message
      }
      ... on Token {
        accessToken
        refreshToken
        expiresEpoch
        expiresInSec
        idToken
        tokenType
        user {
          uuid
          username
        }
      }
    }
  }
`);

export function useLoginMutation() {
  const [loginUser, { loading, error, reset }] = useMutation(USER_LOGIN);

  return {
    loginUser,
    loading,
    error,
    reset,
  };
}
